import { useMediaQuery } from '@material-ui/core'
import React, { createContext, useEffect, useState } from 'react'
import { COMMON_MOBILE_BREAKPOINT } from '../constants'

export const ContactUsCollapseContext = createContext()

const ContactUsCollapseContexProvider = ({ children }) => {
  const isMobile = useMediaQuery(COMMON_MOBILE_BREAKPOINT)
  const [isCollpased, setIsCollapsed] = useState(false)

  useEffect(() => {
    if (isMobile) setIsCollapsed(true)
  }, [isMobile])

  return (
    <ContactUsCollapseContext.Provider value={[isCollpased, setIsCollapsed]}>
      {children}
    </ContactUsCollapseContext.Provider>
  )
}

export default ContactUsCollapseContexProvider
